import "react-toastify/dist/ReactToastify.css";

import { useContext } from "react";
import ExternalTransferForm from "./ExternalTransferForm";
import InternalTransferForm from "./InternalTransferForm";
import { WithdrawContext } from "../../context/WithdrawContext";
import { useLocation } from "react-router-dom";

function WithdrawalTransferManager() {
  const { balance, transferType } = useContext(WithdrawContext);
  const location=useLocation()

  return (
    <figure className="w-full gap-4  ">
      {transferType === "internal" ? (
        <InternalTransferForm balance={balance} initial={location.state} />
      ) : (
        <ExternalTransferForm balance={balance} initial={location.state} />
      )}
    </figure>
  );
}

export default WithdrawalTransferManager;
